import { LIST_REQUEST, RECIEVE_LIST, SET_LIST_URL, SET_LIST } from "../action_types";

export const setListUrlReducer = (url = 'https://vendorlist.consensu.org/vendorlist.json', action) => {
    switch(action.type) {
        case SET_LIST_URL:
            return action.url;
        default: return url;
    };
};

export const getListReducer = (state = {
    isFetching: false,
    list: {
        purposes: [],
        features: [],
        vendors: [],
    },
}, action) => {
    switch(action.type) {
        case LIST_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });

        case RECIEVE_LIST:
            return Object.assign({}, state, {
                isFetching: false,
            });

        case SET_LIST:
                return Object.assign({}, state, { 
                    list: action.list,
                });
        
        default: return state;
    }
}
